module.exports = __webpack_public_path__ + "img/headingEle.96313162.svg";